import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import { isNil } from 'lodash-es';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { JobInvoicing } from '~hooks/useJob/models';

interface TotalHoursColumnProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function TotalHoursColumn({ job, sx }: TotalHoursColumnProps) {
  const {
    approvedWorkTimeMinutes,
    workTimeMinutes,
    adjustedLoggingEndedAt,
    loggingEndedAt,
    adjustedLoggingStartedAt,
    loggingStartedAt,
  } = job.jobSummary ?? {};

  const workTime = approvedWorkTimeMinutes ?? workTimeMinutes;
  const totalHrs = isNil(workTime) ? null : `${(workTime / 60).toFixed(2)}h`;

  const effectiveLoggingStartedAt = adjustedLoggingStartedAt ?? loggingStartedAt;
  let startTime = null;
  if (effectiveLoggingStartedAt) {
    startTime = dayjs.tz(effectiveLoggingStartedAt).format('h:mm A');
  }

  const effectiveLoggingEndedAt = adjustedLoggingEndedAt ?? loggingEndedAt;
  let stopTime = null;
  if (effectiveLoggingEndedAt) {
    stopTime = dayjs.tz(effectiveLoggingEndedAt).format('h:mm A');
  }

  return (
    <Box sx={sx}>
      <FlexColumn>
        {totalHrs && <OverflowAwareText fontWeight={700}>{totalHrs}</OverflowAwareText>}

        <OverflowAwareText>
          {startTime ?? '-'} - {stopTime ?? '-'}
        </OverflowAwareText>
      </FlexColumn>
    </Box>
  );
}
